import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import Icon from '../Icon';

import css from './BannerLayout.module.scss';

interface Props extends PropsWithChildren {
  visible: boolean;
  className?: string;
  closeBtnClassName?: string;
  size?: 'default' | 'large';
  onCloseClick: () => void;
}

const BannerLayout: React.FC<Props> = (props) => {
  const { onCloseClick, children, size = 'default', closeBtnClassName = '', visible, className = '' } = props;

  return (
    <div className={cn(css.banner, css[size], visible && css.visible, className)}>
      {children}
      <button className={cn(css.closeButton, closeBtnClassName)} onClick={onCloseClick}>
        <Icon type="close" />
      </button>
    </div>
  );
};

export default BannerLayout;
